import type { Messages } from '../catalogue.en'

export const tracker: Partial<Messages> = {
  'tracker.trigger': 'Сообщить о проблеме',
  'tracker.dialogTitle': 'Новая задача',
  'tracker.foldWindow': 'Свернуть окно отчёта',
  'tracker.unfoldWindow': 'Развернуть окно отчёта',
  'tracker.moveWindow': 'Переместить окно отчёта',
  'tracker.description': 'Описание',
  'tracker.charactersLeft': 'Осталось {count}',
  'tracker.context': 'Отправляется вместе с отчётом автоматически.',
  'tracker.module': 'Модуль',
  'tracker.screen': 'Экран',
  'tracker.agent': 'Назначить агенту',
  'tracker.agentsLoading': 'Загрузка доступности агентов…',
  'tracker.agentsUnavailable': 'Доступность агентов неизвестна. Задачу всё равно можно создать.',
  'tracker.agentFree': 'Свободен',
  'tracker.agentBusy': 'Занят',
  'tracker.agentOffline': 'Не в сети',
  'tracker.agentModel': 'Модель: {model}',
  'tracker.agentCurrentWork': 'Текущая работа: {summary}',
  'tracker.attachments': 'Вложения',
  'tracker.optional': 'Необязательно',
  'tracker.chooseAttachments': 'Выбрать вложения',
  'tracker.attachmentCountOne': '{count} вложение',
  'tracker.attachmentCountMany': 'Вложений: {count}',
  'tracker.attachmentNumber': '{number}.',
  'tracker.attachmentOn': 'Добавлено на экране {screen}',
  'tracker.removeAttachment': 'Удалить вложение {number}',
  'tracker.attachmentLimit': 'К одной задаче можно прикрепить до {count} поддерживаемых файлов.',
  'tracker.unsavedIntent': 'Отчёт об ошибке \u2014 ещё не отправлен',
  'tracker.openIssues': 'Открытые задачи',
  'tracker.opening': 'Открытие задач',
  'tracker.popupBlocked': 'Трекер задач не удалось открыть в новой вкладке.',
  'tracker.cancel': 'Отмена',
  'tracker.submit': 'Создать задачу',
  'tracker.submitting': 'Создание задачи',
  'tracker.created': 'Задача №{number} создана.',
  'tracker.createdDetail': 'Сохранено в трекере.',
  'tracker.assignedAgent': 'Отправлено агенту {agent}.',
  'tracker.reportAnother': 'Сообщить ещё',
  'tracker.close': 'Закрыть',
  'tracker.attachmentWarning': 'Задача создана, но вложение не удалось загрузить.',
  'tracker.releaseCheckWarning': 'Фоллоап-задача создана, но релизную задачу не удалось пометить проверенной. Повторите «Проверено» на вкладке «Релиз».',
  'tracker.dispatchWarning': 'Задача создана, но назначение агенту не выполнено.',
  'tracker.errorTooLarge': 'Вложения слишком велики в сумме.',
  'tracker.errorUnsupported': 'Используйте файлы PNG, JPEG, WebP, PDF, JSON, Markdown или обычный текст.',
  'tracker.errorForbidden': 'Ваша учётная запись не может создавать задачи.',
  'tracker.errorSignedOut': 'Ваш сеанс завершён. Войдите снова, затем отправьте этот отчёт.',
  'tracker.errorRefused': 'Отчёт отклонён в том виде, как он написан. Измените его и попробуйте ещё раз.',
  'tracker.errorUnavailable': 'Создание не удалось подтвердить. Ваш репорт сохранён в этой форме. Повторите попытку, чтобы проверить или отправить его.',
  'tracker.errorChanged': 'Предыдущая попытка уже создала отчёт с другим содержимым. Проверьте «Мои отчёты», прежде чем отправлять этот снова.',
  'tracker.myReports': 'Мои отчёты',
  'tracker.openReport': 'Открыть отчёт №{number}',
  'tracker.tabs': 'Разделы окна задач',
  'tracker.tabReport': 'Репорт',
  'tracker.tabRelease': 'Релиз',
  'tracker.release.title': 'Проверка релиза',
  'tracker.release.subtitle': 'Закрытые задачи трекера, которые ещё нужно проверить вручную.',
  'tracker.release.includeChecked': 'Показывать проверенные',
  'tracker.release.loading': 'Загрузка задач релиза',
  'tracker.release.empty': 'Нет задач, ожидающих проверки релиза',
  'tracker.release.emptyDetail': 'Закрытые задачи с release/checked скрыты по умолчанию.',
  'tracker.release.listLabel': 'Задачи для проверки релиза',
  'tracker.release.noRelease': 'Нет метки релиза',
  'tracker.release.checkedState': 'Уже проверена',
  'tracker.release.check': 'Проверено',
  'tracker.release.checking': 'Отмечаем проверенной',
  'tracker.release.fix': 'Исправить',
  'tracker.release.followUpFor': 'Фоллоап',
  'tracker.release.followUpDraft': 'Фоллоап к закрытой задаче №{number}: {title}',
  'tracker.release.errorChanged': 'Задача изменилась в трекере. Обновите вкладку «Релиз» и попробуйте снова.',
  'tracker.release.errorNotClosed': 'Проверенной можно отметить только закрытую задачу.',
  'tracker.release.errorGone': 'Этой задачи больше нет в списке проверки релиза.',

  'tracker.reports.title': 'Отчёты',
  'tracker.reports.subtitle': 'Отчёты о проблемах, отправленные из этого приложения.',
  'tracker.reports.tableLabel': 'Реестр отчётов',
  'tracker.reports.scopeLabel': 'Охват',
  'tracker.reports.scopeMine': 'Мои отчёты',
  'tracker.reports.scopeAll': 'Все отчёты',
  'tracker.reports.loading': 'Загрузка отчётов',
  'tracker.reports.loadFailed': 'Не удалось загрузить отчёты.',
  'tracker.reports.forbidden': 'Ваша учётная запись не может открывать отчёты.',
  'tracker.reports.empty': 'Отчётов пока нет',
  'tracker.reports.emptyDetail': 'Здесь появятся отчёты, отправленные из этого приложения.',
  'tracker.reports.columnNumber': 'Номер',
  'tracker.reports.columnTitle': 'Название',
  'tracker.reports.columnReporter': 'Автор',
  'tracker.reports.columnEnvironment': 'Среда',
  'tracker.reports.columnState': 'Состояние',
  'tracker.reports.columnWork': 'Работа',
  'tracker.reports.columnCreated': 'Создан',
  'tracker.reports.columnUpdated': 'Обновлён',
  'tracker.reports.columnActions': 'Действия',
  'tracker.reports.openNamed': 'Открыть отчёт №{number}',
  'tracker.reports.deleteNamed': 'Удалить отчёт №{number}',
  'tracker.reports.reload': 'Обновить список',
  'tracker.reports.reloaded': 'Список обновлён.',
  'tracker.reports.reloadFailed': 'Не удалось обновить список.',

  'tracker.report.title': 'Отчёт',
  'tracker.report.number': '№{number}',
  'tracker.report.back': 'К списку отчётов',
  'tracker.report.loading': 'Загрузка отчёта',
  'tracker.report.loadFailed': 'Не удалось загрузить отчёт.',
  'tracker.report.notFound': 'Такого отчёта нет, или он был удалён.',
  'tracker.report.forbidden': 'Ваша учётная запись не может открыть этот отчёт.',
  'tracker.report.state': 'Состояние',
  'tracker.report.stateOpen': 'Открыт',
  'tracker.report.stateClosed': 'Закрыт',
  'tracker.report.work': 'Работа',
  'tracker.report.started': 'Взят в работу',
  'tracker.report.notStarted': 'Не начат',
  'tracker.report.reporter': 'Автор',
  'tracker.report.environment': 'Среда',
  'tracker.report.created': 'Создан',
  'tracker.report.updated': 'Обновлён',
  'tracker.report.readOnlyNote': 'Этот отчёт больше нельзя изменять из вашей учётной записи.',
  'tracker.report.readOnlyComments': 'Комментарии по-прежнему можно добавлять.',
  'tracker.report.description': 'Описание',
  'tracker.report.noDescription': 'Без описания.',
  'tracker.report.attachments': 'Вложения отчёта',
  'tracker.report.attachmentWarning': 'Изменение сохранено, но одно из вложений не удалось загрузить.',
  'tracker.report.comments': 'Комментарии',
  'tracker.report.noComments': 'Комментариев пока нет.',
  'tracker.report.commentEdited': 'Изменён',
  'tracker.report.commentAttachments': 'Вложения комментария',
  'tracker.report.commentLabel': 'Новый комментарий',
  'tracker.report.commentHint': 'Markdown. Изображение, вставленное в поле, будет приложено.',
  'tracker.report.commentReadOnly': 'К этому отчёту больше нельзя добавлять комментарии. Ваш черновик сохранён в этой форме.',
  'tracker.report.send': 'Добавить комментарий',
  'tracker.report.sending': 'Добавление комментария',
  'tracker.report.commentAdded': 'Комментарий добавлен.',
  'tracker.report.editDescription': 'Изменить описание',
  'tracker.report.editTitle': 'Изменить название',
  'tracker.report.titleField': 'Название',
  'tracker.report.saveTitle': 'Сохранить название',
  'tracker.report.savingTitle': 'Сохранение названия',
  'tracker.report.titleSaved': 'Название сохранено.',
  'tracker.report.cancelTitle': 'Отменить изменение названия',
  'tracker.report.save': 'Сохранить изменения',
  'tracker.report.saving': 'Сохранение',
  'tracker.report.saved': 'Изменения сохранены.',
  'tracker.report.close': 'Закрыть отчёт',
  'tracker.report.closing': 'Закрытие',
  'tracker.report.closeTitle': 'Закрыть отчёт №{number}?',
  'tracker.report.closeDescription': 'Закрытый отчёт остаётся доступным для чтения и комментариев, но его больше нельзя изменять здесь.',
  'tracker.report.closeConfirm': 'Закрыть отчёт',
  'tracker.report.closed': 'Отчёт закрыт.',
  'tracker.report.delete': 'Удалить отчёт',
  'tracker.report.deleting': 'Удаление',
  'tracker.report.deleteTitle': 'Удалить отчёт №{number}?',
  'tracker.report.deleteDescription': 'Отчёт и его комментарии будут удалены из трекера. Это действие нельзя отменить.',
  'tracker.report.deleteConfirm': 'Удалить',
  'tracker.report.deleted': 'Отчёт №{number} удалён.',
  'tracker.report.reload': 'Перезагрузить отчёт',
  'tracker.report.reloaded': 'Отчёт перезагружен. Просмотрите его и попробуйте снова.',
  'tracker.report.reloadFailed': 'Не удалось перезагрузить отчёт.',
  'tracker.report.unsavedTitle': 'Название отчёта \u2014 ещё не сохранено',
  'tracker.report.unsavedDescription': 'Описание отчёта \u2014 ещё не сохранено',
  'tracker.report.unsavedComment': 'Комментарий \u2014 ещё не добавлен',
  'tracker.report.errorChanged': 'Отчёт изменился с момента загрузки. Перезагрузите его и попробуйте снова.',
  'tracker.report.errorReadOnly': 'Отчёт взят в работу, и его больше нельзя изменить здесь.',
  'tracker.report.errorUncertain': 'Изменение не удалось подтвердить. Ваш черновик сохранён в этой форме. Повторите попытку, чтобы проверить или отправить его.',
  'tracker.report.errorUnavailable': 'Трекер сейчас недоступен. Ваш черновик сохранён в этой форме. Попробуйте позже.',
  'tracker.report.errorForbidden': 'Ваша учётная запись не может изменять этот отчёт.',
  'tracker.report.errorGone': 'Этого отчёта больше нет.',
  'tracker.report.errorRefused': 'Изменение отклонено в том виде, как оно написано. Исправьте его и попробуйте снова.',

  'tracker.editor.tabs': 'Режим редактора',
  'tracker.editor.write': 'Текст',
  'tracker.editor.preview': 'Просмотр',
  'tracker.editor.toolbar': 'Форматирование',
  'tracker.editor.heading': 'Заголовок',
  'tracker.editor.bold': 'Полужирный',
  'tracker.editor.italic': 'Курсив',
  'tracker.editor.strikethrough': 'Зачёркнутый',
  'tracker.editor.quote': 'Цитата',
  'tracker.editor.code': 'Код',
  'tracker.editor.link': 'Ссылка',
  'tracker.editor.bulletedList': 'Маркированный список',
  'tracker.editor.numberedList': 'Нумерованный список',
  'tracker.editor.taskList': 'Список задач',
  'tracker.editor.nothingToPreview': 'Пока нечего показывать.',
}
